/* Newsletter dual-write: posts to Klaviyo client/subscriptions AND Shopify /contact.
   Klaviyo POST adds the email to the welcome flow's trigger list (VdhmrG).
   Shopify POST creates a subscribed customer record.

   Each form opts in by setting data-gu-newsletter-form and data-gu-source="<label>".
   The form should sit inside [data-gu-newsletter-block] containing two siblings:
     [data-gu-newsletter-state="form"]    visible until Klaviyo accepts the email
     [data-gu-newsletter-state="success"] hidden until then
   Optional [data-gu-newsletter-error] for inline error text.
*/
(function () {
  var NEWSLETTER_WORKER_URL = 'https://grumpy-newsletter.thegrumpyunicorn.workers.dev/';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  /* ---- Ad attribution capture ----------------------------------------------
     Records the marketing tags (utm_*, fbclid) from the landing URL into a
     30-day cookie so a signup that happens later — on a page with no tags in
     the URL (e.g. the footer) — still knows it came from a paid ad. Exposed
     as window.guGetAttribution() so the signup forms can attach it.
     This asset is loaded globally in theme.liquid, so the capture runs on
     every page. Wrapped in try/catch — must never interfere with anything. */
  var ATTR_COOKIE = 'gu_attribution';
  var ATTR_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid'];

  function readCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()\[\]\\\/+^])/g, '\\$1') + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }
  function writeCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 864e5);
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + d.toUTCString() + '; path=/; SameSite=Lax';
  }
  function captureAttribution() {
    try {
      var params = new URLSearchParams(window.location.search);
      var found = {};
      for (var i = 0; i < ATTR_KEYS.length; i++) {
        var v = params.get(ATTR_KEYS[i]);
        if (v) found[ATTR_KEYS[i]] = String(v).slice(0, 200);
      }
      // Only (over)write when this visit actually carries tags — a later
      // tag-less visit keeps the last paid touch (30-day window).
      if (Object.keys(found).length) {
        found.landing_page = String(window.location.pathname || '').slice(0, 200);
        found.captured_at = new Date().toISOString();
        writeCookie(ATTR_COOKIE, JSON.stringify(found), 30);
      }
    } catch (e) {}
  }
  function getAttribution() {
    try {
      var raw = readCookie(ATTR_COOKIE);
      return raw ? JSON.parse(raw) : {};
    } catch (e) {
      return {};
    }
  }
  window.guGetAttribution = getAttribution;
  captureAttribution();

  function tagFor(source) {
    return source.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }

  function bind(form) {
    if (form.dataset.guBound === '1') return;
    form.dataset.guBound = '1';

    var block = form.closest('[data-gu-newsletter-block]') || form.parentNode;
    var source = form.dataset.guSource
      || (block && block.dataset && block.dataset.guSource)
      || 'Storefront';
    var formState = block.querySelector('[data-gu-newsletter-state="form"]');
    var successState = block.querySelector('[data-gu-newsletter-state="success"]');
    var errorEl = block.querySelector('[data-gu-newsletter-error]');

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var emailInput = form.querySelector('input[type="email"]');
      if (!emailInput) return;
      var email = (emailInput.value || '').trim();
      if (!email || !EMAIL_RE.test(email)) {
        if (errorEl) { errorEl.textContent = 'That email looks off. Mind checking it?'; errorEl.hidden = false; }
        emailInput.focus();
        return;
      }
      if (errorEl) errorEl.hidden = true;

      var submitBtn = form.querySelector('button[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;

      // Fire-and-forget Shopify customer creation. Same pattern as the popup.
      try {
        var shopifyForm = new FormData();
        shopifyForm.append('form_type', 'customer');
        shopifyForm.append('utf8', '✓');
        shopifyForm.append('contact[email]', email);
        shopifyForm.append('contact[tags]', 'newsletter,' + tagFor(source));
        shopifyForm.append('contact[accepts_marketing]', 'true');
        fetch('/contact', {
          method: 'POST',
          body: shopifyForm,
          credentials: 'same-origin'
        }).catch(function () {});
      } catch (err) {}

      fetch(NEWSLETTER_WORKER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email, source: source, attribution: getAttribution() })
      }).then(function (res) {
        if (res.ok) {
          try { localStorage.setItem('gu_newsletter_signed_up', '1'); } catch (e) {}
          if (window._learnq) {
            try { window._learnq.push(['identify', { '$email': email }]); } catch (e) {}
          }
          if (formState) formState.hidden = true;
          if (successState) successState.hidden = false;
        } else {
          throw new Error('newsletter ' + res.status);
        }
      }).catch(function () {
        if (submitBtn) submitBtn.disabled = false;
        if (errorEl) {
          errorEl.textContent = 'Something broke on my end. Try again?';
          errorEl.hidden = false;
        }
      });
    });
  }

  function bindAll() {
    var forms = document.querySelectorAll('form[data-gu-newsletter-form], form.gu-newsletter-form');
    for (var i = 0; i < forms.length; i++) bind(forms[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }
  document.addEventListener('shopify:section:load', bindAll);
})();
